import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";


import Alert from '@mui/material/Alert';

import loading_image from 'common/assets/images/icons/loading-green-loading.gif'


import ExpoPartecipazioniTable from "./ExpoPartecipazioniTable";
import { ColumnFilter } from "common/components/implemented/Tables/DataTable/ColumnFilter";

import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";

import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import { NoneFilter } from "../expo_richieste_admin/NoneFilter";
import { SelectColumnFilterPostazione } from "../expo_richieste_admin/SelectColumnFilterPostazione";
import { SelectColumnFilterMsgS } from "./SelectColumnFilterMsgS";

import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoModuliTable from "./ExpoModuliTable";


function ExpoModuliList() {

  const [richieste, setRichieste] = useState([]);

  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;

  const [loading, setLoading] = useState(true);


  //per passarmi la variabile se ho salvato e far comparire l'alert
  const location = useLocation();
  const { state } = location != null ? location : { state: { submitted: false, salvato: 'NO', indietro: false } }; // Read values passed on state

  useEffect(() => {

    setRichieste([]);

    setLoading(true);
    filtra();

  }, [manifestazione]);

  function filtra() {
    console.log("FILTRO CON " + manifestazione);
    ExpoPartecipazioniService.getModuliRx(manifestazione)
      .then(response => {
        console.log(response.data);
        setRichieste(response.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });

  }

  const nomi_moduli = [];
  const ppAttributes = [];

  if (richieste.length > 0) {
    richieste.forEach(richiesta => {


      //console.log(partecipazioni);
      let action = (
        <MDBox>
          {/*
          <Link to="/expo_richiestaMessage" state={{ id_proposta: part.id_richiesta0, chiamante: 'expo_partecipazioni_admin' }}
          >
            <MDButton variant="outlined" color={"success"} iconOnly={true}  >
              < AttachEmailIcon />
            </MDButton>   </Link>*/}
          <Link to="/expo_moduli_val" state={{ modo: 'edit', id_soggetto: richiesta.idRichiesta, chiamante: 'expo_moduli_list' }}>
            <MDButton variant="outlined" color={"success"} iconOnly={true}>
              <Icon>edit</Icon>
            </MDButton>
          </Link>
        </MDBox>
      );

      let modulo0 = "NO";
      if (richiesta.moduli_obbligatori[0].id_modulo != null && richiesta.moduli_obbligatori[0].id_modulo != 0) {
        modulo0 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[0].protocollato) {
        modulo0 = "PROT.";

      }
      let modulo1 = "NO";
      if (richiesta.moduli_obbligatori[1].id_modulo != null && richiesta.moduli_obbligatori[1].id_modulo != 0) {
        modulo1 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[1].protocollato) {
        modulo1 = "PROT.";

      }
      let modulo2 = "NO";
      if (richiesta.moduli_obbligatori[2].id_modulo != null && richiesta.moduli_obbligatori[2].id_modulo != 0) {
        modulo2 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[2].protocollato) {
        modulo2 = "PROT.";

      }
      let modulo3 = "NO";
      if (richiesta.moduli_obbligatori[3].id_modulo != null && richiesta.moduli_obbligatori[3].id_modulo != 0) {
        modulo3 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[3].protocollato) {
        modulo3 = "PROT.";

      }
      let modulo4 = "NO";
      if (richiesta.moduli_obbligatori[4].id_modulo != null && richiesta.moduli_obbligatori[4].id_modulo != 0) {
        modulo4 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[4].protocollato) {
        modulo4 = "PROT.";

      }
      let modulo5 = "NO";
      if (richiesta.moduli_obbligatori[5].id_modulo != null && richiesta.moduli_obbligatori[5].id_modulo != 0) {
        modulo5 = "ARRIVATO";

      }
      if (richiesta.moduli_obbligatori[5].protocollato) {
        modulo5 = "PROT.";

      }

    let num_prot= richiesta.protocollo;
if(richiesta.avi){
  num_prot=richiesta.protocollo+"A";
}

      ppAttributes.push({
        richiesta: richiesta,
        idRichiesta: richiesta.idRichiesta,
        mq: richiesta.mq_concessi,
        protocollo:num_prot,
        azienda: richiesta.ragione_sociale,
        action: action,
        tipologia_espositiva_string: richiesta.tipologia_concessa,

        modulo0: modulo0,
        modulo1: modulo1,
        modulo2: modulo2,
        modulo3: modulo3,
        modulo4: modulo4,
        modulo5: modulo5,
      })
    });
  }



  const ppTableData = {
    rows: ppAttributes,

    columns: [

      { Header: "Prot.", accessor: "protocollo", Filter: ColumnFilter, width: "5%", align: "left", id: "moduli_0" },
      { Header: "Azioni", accessor: "action", Filter: NoneFilter, width: "5%", align: "center", enableGlobalFilter: false, id: "moduli_1", disableSortBy: true },
      { Header: "Azienda", accessor: "azienda", Filter: ColumnFilter, align: "left", id: "moduli_2" },
      { Header: "Tipologia Espositiva Assegnata", accessor: "tipologia_espositiva_string", Filter: ColumnFilter, align: "left", with: "10%", id: "moduli_3" },
      { Header: "Mq", accessor: "mq", Filter: ColumnFilter, align: "left", width: "5%", id: "moduli_4" },
      { Header: "Modulo A", accessor: "modulo0", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_6" },
      { Header: "Modulo B", accessor: "modulo1", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_7" },
      { Header: "Modulo C", accessor: "modulo2", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_8" },
      { Header: "Modulo D", accessor: "modulo3", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_9" },
      { Header: "Modulo E", accessor: "modulo4", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_10" },
      { Header: "Modulo F", accessor: "modulo5", Filter: ColumnFilter, align: "left", width: "7%", id: "moduli_11" },

    ],



  };

  const mypagination = { color: 'success', variant: "contained" };




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>
              <HeaderForm titolo={"Moduli Obbligatori Espositori " + manifestazione} add="" modo="vis" />
              <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">

                {(state != null && state.submitted && (state.salvato === 'INS' || state.salvato === 'MOD')) &&

                  <Alert severity="success">Dati salvati con successo!</Alert>}

                {(state != null && state.submitted && state.salvato === 'DEL') &&

                  <Alert severity="success">Dati eliminati con successo!</Alert>}
              </MDBox>


              <MDBox pt={3}>
                <ExpoModuliTable
                  table={ppTableData}
                  nome_tabella="moduli"
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  pagination={mypagination}
                  noEndBorder
                  responsive={true}
                  first_load={state == null || !state.indietro}
                  filtro_server={true}
                  canExport={true}
                  canSend={true}
                  enableColumnFilters={true}
                  chiamante='expo_moduli_list'
                  filtra={filtra}
                />
              </MDBox>
              {loading &&
                <MDBox opacity={1} textAlign="center">
                  <img src={loading_image} alt="loading" width={100} />
                </MDBox>
              }

              {(richieste == null || richieste.length === 0) &&
                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non ci sono Espositori x la manifestazione selezionata.
                  </MDTypography></MDBox>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ExpoModuliList;
